import { render, staticRenderFns } from "./ReturnExchangeDesc.vue?vue&type=template&id=0529773c&scoped=true&"
var script = {}
import style0 from "./ReturnExchangeDesc.vue?vue&type=style&index=0&id=0529773c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0529773c",
  null
  
)

export default component.exports